import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SelectOption } from 'src/app/ui/form-field/form-field.component';
import { IWorkflowTriggerDescriptor, WorkflowTriggerType } from '../../models/workflows.models';

@Component({
  selector: 'app-workflow-trigger-select',
  templateUrl: './workflow-trigger-select.component.html',
  styleUrls: ['./workflow-trigger-select.component.scss'],
})
export class WorkflowTriggerSelectComponent {
  @Input() triggers: IWorkflowTriggerDescriptor[] = [];
  @Input() selectedType: WorkflowTriggerType | null = null;
  /** Fixed by the template: the trigger cannot be changed for the rule's life.
   *  A template rule that no longer suits gets paused or archived, not rewired. */
  @Input() locked = false;
  @Output() triggerChanged = new EventEmitter<WorkflowTriggerType>();

  constructor(private translate: TranslateService) {}

  get triggerOptions(): SelectOption[] {
    return this.triggers.map((trigger) => ({
      label: this.translate.instant(trigger.i18nLabel),
      value: trigger.type,
      disabled: trigger.disabled,
    }));
  }

  onSelect(type: WorkflowTriggerType | null): void {
    if (!type || this.locked) {
      return;
    }
    this.triggerChanged.emit(type);
  }
}
